import { useEffect, useState } from "react";
import CenterPad from "../../Components/CenterPad/CenterPad";
import Loadable from "../../Components/Loadable/Loadable";
import "./AcceptInvitationPage.scss";
import { Link, useSearchParams } from "react-router-dom";
import ApiService from "../../Services/ApiService";
import { IAPIResponse } from "../../Services/AjaxService";
import { ToastMessage } from "../../Utils/UIMessages";
import Tr from "../../Utils/Translations/Translations";
import { Icon } from "@fluentui/react";
import { AppRoutes } from "../../AppRoutes";
import { mobileCheck } from "../../App";
import { GenerateAssetUrl } from "../../Components/ImageAssetLoader/ImageAssetLoader";
import Generic from "../../Utils/Generic";

const AcceptInvitationPage = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [loading, setLoading] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const validateToken = () => {
    if (token) {
      setError(false);
      setLoading(true);
      ApiService.WorkGroupController.AcceptInvitation(
        token,
        (response: IAPIResponse) => {
          if (response.error === null) {
            setDone(true);
            ToastMessage(
              "success",
              Tr.Translate("language", "invitation_accepted")
            );
          } else {
            setError(true);
          }
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    validateToken();
  }, []);

  return (
    <div
      className="accept-invitation-page-wrap"
      style={Generic.GetRandomBackgroundUrlCss()}
    >
      <CenterPad
        content={
          <Loadable
            isLoading={loading}
            content={
              <div className="accept-invitation--inner-frame">
                {done && (
                  <div>
                    <div className="accept-invitation-done-icon">
                      <div>{Tr.Translate("language", "done")}</div>
                      <Icon iconName="SkypeCircleCheck" />
                    </div>
                    <div className="accept-invitation-done-subtitle">
                      {Tr.Translate("language", "invitation_accepted")}
                    </div>
                  </div>
                )}
                {error && (
                  <div
                    className="accept-invitation-not-done-icon"
                    style={mobileCheck() ? { fontSize: "1.2em" } : {}}
                  >
                    <div>{Tr.Translate("system", "invalid_token")}</div>
                    <Icon iconName="StatusErrorFull" />
                  </div>
                )}
                <hr />
                <div className="flex-line">
                  <Link to={AppRoutes.LOGIN_PAGE}>
                    {Tr.Translate("language", "back")}
                  </Link>
                </div>
              </div>
            }
          />
        }
      />
    </div>
  );
};

export default AcceptInvitationPage;
